// src/properties/propertyAmenitiesApi.ts
import { apiClient } from "@maat/api-base";
var propertyAmenitiesApi = {
  async getPropertyAmenities(category, popular, search, scope) {
    const params = {};
    if (category) params.category = category;
    if (popular) params.popular = "true";
    if (search) params.search = search;
    if (scope) params.scope = scope;
    return await apiClient.get("/main/api/property-amenities", {
      params
    });
  },
  // Admin: toggle the popularity flag (requireAdmin-gated).
  async setPopular(id, isPopular) {
    return await apiClient.patch(
      `/main/api/admin/property-amenities/${id}`,
      {
        is_popular: isPopular
      }
    );
  }
};

export {
  propertyAmenitiesApi
};
